import { ICoordinates } from "../../components/pages/estimate/interfaces";
import fetcher from "../../lib/fetcher";
import useSWR from "swr";

export interface IGeoPolygonsSchema {
  id: number;
  name: string;
  coordinates: ICoordinates[];
  color: string;
}

export interface IGeoPolygonsTransform {
  id: number;
  name: string;
  coordinates: { lat: number; lon: number }[];
  color: string;
}

interface IGeoPolygonsResponse {
  data: IGeoPolygonsSchema[];
}

const useGeoPolygons = () => {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    `/geo/polygon`,
    (url) => fetcher.swr<IGeoPolygonsResponse>(url),
    {}
  );

  const dataTransform = (function () {
    return data?.data.map((itemData) => {
      return {
        ...itemData,
        coordinates: itemData.coordinates.map((coord) => ({
          lat: coord.latitude,
          lon: coord.longitude,
        })),
      };
    });
  })();

  return {
    polygons: (dataTransform as IGeoPolygonsTransform[]) ?? [],
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useGeoPolygons;
